import LinkedinSettings from './linkedinSettings.view';

export default LinkedinSettings;
